import almaPic from "@/public/images/artists/alma.png";
import { Artist } from "@/types/types";

export const alma = {
  id: "136",
  name: "Alma",
  image: almaPic,
  description: `Alma's voice is sweet and youthful with a gentle touch, excelling in sotto voce singing. Her delicate tones bring a soft and captivating charm to every track and are well-suited for modern pop and dance music with Latin influences.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Falma-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Latin", "Pop", "Dance", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 52,
        high: 72,
      },
      sweetSpot: 65,
    },
  },
} as const satisfies Artist;
